const encodeKey = (value) => btoa(value);
const decodeKey = (value) => atob(value);

const dev = {
    env: "dev",
    key: encodeKey("wg_81f95cc7566abfec93bd81f617f19d8e6")
};

const qa = {
    env: "qa",
    key: encodeKey("wg_4b5cd42d910dada6e0770505f0c04ada3")
};

const prod = {
    env: "prod",
    key: encodeKey("wg_d45051fb84304b4d9020a462e4701c1e3")
};

const Weglot_Config =
    process.env.REACT_APP_STAGE === "prod"
      ? prod
      : process.env.REACT_APP_STAGE === "qa"
      ? qa
      : dev;

const WEGLOT_CONFIG = {
    ...Weglot_Config,
    key: decodeKey(Weglot_Config.key)
};

export default WEGLOT_CONFIG;
  